<template>
    <dashboard-layout title="회원탈퇴">
        <template #contents>
            <v-tabs-items :value="tab">
                <v-tab-item value="info">
                    <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                        <span> 탈퇴안내 </span>
                    </h5>
                    <ul class="letter-list">
                        <li><em>-</em><span>회원탈퇴 시 연관 데이터가 모두 삭제되며, 동일한 아이디로 재가입 하더라도 복원되지 않습니다.</span></li>
                    </ul>

                    <div class="mt-30 mt-md-50">
                        <div class="v-btn--group v-btn--group--large">
                            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" to="/dashboard/withdraw/action">
                                <span> 계속하기 </span>
                            </v-btn>
                        </div>
                    </div>
                </v-tab-item>

                <v-tab-item value="action">
                    <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                        <span> 탈퇴정보 </span>
                    </h5>

                    <vertical-form-table v-model="form" v-bind="{ items }" />

                    <div class="mt-30 mt-md-50">
                        <div class="v-btn--group v-btn--group--large">
                            <v-btn v-bind="{ loading }" outlined color="grey-cb" class="min-w-140px min-w-lg-160px" to="/dashboard/withdraw" exact><span class="primary--text">취소</span></v-btn>
                            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="withdraw">탈퇴신청</v-btn>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { rules } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "withdrawalReason",
        term: "탈퇴 사유",
        type: "text",
        required: true,
    },
    {
        key: "withdrawalMessage",
        term: "남기실 말씀",
        type: "textarea",
        autoGrow: true,
    },
    {
        key: "password",
        term: "비밀번호",
        type: "password",
        placeholder: "비밀번호를 입력하세요",
        autocomplete: "new-password",
        rules: rules.password,
        required: true,
    },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        DashboardLayout,
        VerticalFormTable,
    },
    props: {
        tab: { type: String, default: "info" },
    },
    data: () => ({
        items,

        form: {
            withdrawalReason: null,
            withdrawalMessage: null,
            password: null,
        },

        loading: false,
    }),
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        tab() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
    methods: {
        init() {
            if (!this.accessToken) {
                alert("로그인 이후 이용가능합니다");
                this.$router.push("/login");
                return;
            }
        },

        async validate() {
            try {
                if (!this.form.withdrawalReason) throw new Error("탈퇴사유를 입력하세요");
                if (!this.form.password) throw new Error("비밀번호를 입력하세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async withdraw() {
            if (!confirm("탈퇴 시 연관 데이터가 모두 삭제되며, 동일한 아이디로 재가입 하더라도 복원되지 않습니다.\n계속하시겠습니까?")) return
            if (!(await this.validate())) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { password, ...form } = this.form;
                form.password = CryptoAES.encrypt(password);
                await api.v1.me.withdraw(form);

                alert("탈퇴처리 되었습니다");
            } finally {
                this.loading = false;
                this.$store.dispatch("logout").then(() => this.$router.push("/"));
            }
        },
    },
};
</script>
